import { render } from "./Database.vue?vue&type=template&id=548ca36c"
import script from "./Database.vue?vue&type=script&lang=js"
export * from "./Database.vue?vue&type=script&lang=js"
script.render = render

export default script